module.exports = __webpack_public_path__ + "static/media/caret-up.443b2c27.svg";